'use client'

import React from 'react'
import dynamic from 'next/dynamic'

import { useSetLanguageCookie } from '@/src/utils/language'
import { Offer } from '@/src/types/offers'

const DesktopHomepageCarousel = dynamic(() => import('./homepageCarousel'), { ssr: true })
const MobileHomepageCarousel = dynamic(() => import('./mobileHomepageCarousel'), { ssr: true })

interface HomepageCarouselProps {
    offers: Offer[]
    locale: string
    isMobile: boolean
}

export const HomepageCarousel: React.FC<HomepageCarouselProps> = ({ offers, locale, isMobile }) => {
    useSetLanguageCookie()

    if (!offers?.length) {
        return null
    }

    return isMobile ? (
        <MobileHomepageCarousel offers={offers} locale={locale} />
    ) : (
        <DesktopHomepageCarousel offers={offers} locale={locale} />
    )
}

export default HomepageCarousel
